/**
* Scrolling Text JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Text component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    className: 'scrolling-text',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      // const initGSAP = () => {
      //   const scrollingTextWrappers = document.querySelectorAll( '.scrolling-text' );

      //   scrollingTextWrappers.forEach( ( wrapper ) => {
      //     const imageElement = wrapper.querySelector( '.scrolling-text__image' );
      //     const contentWrapper = wrapper.querySelector( '.scrolling-text__content-wrapper' );

      //     if ( imageElement && contentWrapper ) {
      //       const imageStartY = imageElement.getBoundingClientRect().top;
      //       const imageHeight = imageElement.offsetHeight;

      //       ScrollTrigger.create( {
      //         trigger: contentWrapper,
      //         start: 'top top',
      //         end: () => `+=${contentWrapper.scrollHeight}`, // End based on content height
      //         pin: imageElement,
      //         pinSpacing: false,
      //         scrub: true,
      //         markers: true, // Keep markers for debugging
      //         onUpdate: ( self ) => {
      //           const scrollY = self.scroll();
      //           const contentRect = contentWrapper.getBoundingClientRect();
      //           const wrapperRect = wrapper.getBoundingClientRect();

      //           // Calculate the maximum Y position the image should move to
      //           const maxOffset = contentRect.bottom - wrapperRect.top;

      //           // Calculate the amount to move the image
      //           let yOffset = -scrollY;

      //           // Ensure the image stays within the visible bounds
      //           yOffset = Math.max( yOffset, -( imageHeight - ( wrapperRect.height - contentRect.top ) ) );
      //           yOffset = Math.min( yOffset, 0 );

      //           // Prevent the image from scrolling too far down
      //           if ( yOffset < -( imageHeight - wrapperRect.height ) ) {
      //             yOffset = -( imageHeight - wrapperRect.height );
      //           }

      //           gsap.set( imageElement, {y: yOffset} );
      //         },
      //       } );
      //     }
      //   } );
      // };

      // const checkScreenSize = () => {
      //   if ( window.innerWidth >= 769 ) {
      //     initGSAP();
      //   } else {
      //     ScrollTrigger.getAll().forEach( ( trigger ) => trigger.kill() );
      //   }
      // };

      // window.addEventListener( 'load', checkScreenSize );
      // window.addEventListener( 'resize', checkScreenSize );
    },
    finalize: function() {},
  };

  // Register the component
  app.registerComponent( 'scrolling-text', COMPONENT );
} )( app );
